import type AvailableActionsEnum from '../enums/AvalableActionsEnum'
import { JsonObject, JsonProperty } from 'json2typescript'
import AvalableActionsEnumArrayConverter from '@/converters/AvailableActionsEnumArrayConverter'
import PolicyStatusEnumConverter from '@/converters/PolicyStatusEnumConverter'
import ProductEnumConverter from '@/converters/ProductEnumConverter'
import DateConverter from '../../converters/DateConverter'
import PolicyStatusEnum from '../enums/PolicyStatusEnum'
import ProductEnum from '../enums/ProductEnum'
import RenewalStatusEnum from '../enums/RenewalStatusEnum'
import SummaryItem from './SummaryItem'

@JsonObject('PolicySummary')
export default class PolicySummary {
  @JsonProperty('policyNumber', String)
  policyNumber = ''

  @JsonProperty('policyStatus', PolicyStatusEnumConverter)
  policyStatus: PolicyStatusEnum = PolicyStatusEnum.live

  @JsonProperty('renewalStatus', PolicyStatusEnumConverter)
  renewalStatus: RenewalStatusEnum = RenewalStatusEnum.notSet

  @JsonProperty('product', ProductEnumConverter)
  product: ProductEnum = ProductEnum.modernCar

  @JsonProperty('effectiveDate', DateConverter)
  effectiveDate: Date = new Date()

  @JsonProperty('renewalDate', DateConverter)
  renewalDate: Date = new Date()

  @JsonProperty('summaryItems', [SummaryItem])
  summaryItems: SummaryItem[] = []

  @JsonProperty('availableActions', AvalableActionsEnumArrayConverter)
  availableActions: AvailableActionsEnum[] = []

  @JsonProperty('renewalQuoteReference', String)
  renewalQuoteReference: string | null = null

  @JsonProperty('vaps', [String])
  vaps: string[] = []

  @JsonProperty('schemeName', String)
  schemeName: string | null = null

  @JsonProperty('isEligibleFor3YPF', Boolean)
  isEligibleFor3YPF = false

  @JsonProperty('subscriptionCalculatedTotalPayable', Number)
  subscriptionCalculatedTotalPayable: number = 0
}
